export default "/images/loginbg.png?d6222bb20842050ac586189bd0d7ca40";